import { render } from "./DashboardLanding.vue?vue&type=template&id=da60e9f0&scoped=true"
import script from "./DashboardLanding.vue?vue&type=script&lang=js"
export * from "./DashboardLanding.vue?vue&type=script&lang=js"

import "./DashboardLanding.vue?vue&type=style&index=0&id=da60e9f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da60e9f0"]])

export default __exports__